import { useState } from 'react';
import { useTheme } from '../../context/ThemeContext.jsx';
import { AVATAR_COLORS } from './shared.js';

export default function EditUserModal({ user, onClose, onSave }) {
  const { theme, isDark } = useTheme();
  const [name, setName] = useState(user.name);
  const [initials, setInitials] = useState(user.initials || '');
  const [color, setColor] = useState(user.color || '#4F8EF7');

  const handleSave = async () => {
    await onSave(user.id, { name, initials, color });
    onClose();
  };

  return (
    <div
      style={{
        position: 'fixed', inset: 0, zIndex: 300,
        background: theme.overlay, backdropFilter: 'blur(4px)',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
      }}
      onClick={onClose}
    >
      <div onClick={e => e.stopPropagation()} style={{
        width: 400, padding: 28,
        background: isDark ? '#1A1A1E' : '#FFFFFF',
        borderRadius: 14, border: `1px solid ${theme.border}`,
        boxShadow: '0 16px 48px rgba(0,0,0,0.3)',
      }}>
        <h3 style={{ margin: '0 0 20px', fontSize: 16, fontWeight: 700, color: theme.text }}>Edit User</h3>

        <div style={{ marginBottom: 16 }}>
          <label style={{ display: 'block', fontSize: 11, fontWeight: 600, color: theme.textMuted, marginBottom: 6 }}>Name</label>
          <input type="text" value={name} onChange={e => setName(e.target.value)} autoFocus
            style={{ width: '100%', padding: '10px 12px', background: theme.bgInput, border: `1px solid ${theme.borderMedium}`, borderRadius: 8, color: theme.text, fontSize: 13, outline: 'none', fontFamily: 'inherit', boxSizing: 'border-box' }} />
        </div>

        <div style={{ marginBottom: 16 }}>
          <label style={{ display: 'block', fontSize: 11, fontWeight: 600, color: theme.textMuted, marginBottom: 6 }}>Initials</label>
          <input type="text" value={initials} onChange={e => setInitials(e.target.value.toUpperCase().slice(0, 4))} maxLength={4}
            style={{ width: 80, padding: '10px 12px', background: theme.bgInput, border: `1px solid ${theme.borderMedium}`, borderRadius: 8, color: theme.text, fontSize: 13, outline: 'none', fontFamily: 'inherit', textAlign: 'center', letterSpacing: '0.1em', boxSizing: 'border-box' }} />
        </div>

        <div style={{ marginBottom: 24 }}>
          <label style={{ display: 'block', fontSize: 11, fontWeight: 600, color: theme.textMuted, marginBottom: 6 }}>Avatar Color</label>
          <div style={{ display: 'flex', gap: 8, alignItems: 'center' }}>
            {AVATAR_COLORS.map(c => (
              <button key={c} onClick={() => setColor(c)} style={{
                width: 28, height: 28, borderRadius: '50%',
                background: c, border: color === c ? '3px solid #fff' : '2px solid transparent',
                cursor: 'pointer', padding: 0,
                boxShadow: color === c ? `0 0 0 2px ${c}` : 'none',
              }} />
            ))}
          </div>
          <div style={{ marginTop: 12, display: 'flex', alignItems: 'center', gap: 10 }}>
            <div style={{
              width: 36, height: 36, borderRadius: '50%',
              background: color, display: 'flex', alignItems: 'center', justifyContent: 'center',
              fontSize: 13, fontWeight: 700, color: '#fff',
            }}>{initials || '??'}</div>
            <span style={{ fontSize: 12, color: theme.textMuted }}>Preview</span>
          </div>
        </div>

        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
          <button onClick={onClose} style={{ padding: '10px 20px', fontSize: 12, fontWeight: 500, background: theme.bgInput, border: `1px solid ${theme.borderMedium}`, borderRadius: 8, color: theme.textMuted, cursor: 'pointer', fontFamily: 'inherit' }}>Cancel</button>
          <button onClick={handleSave} style={{
            padding: '10px 24px', fontSize: 12, fontWeight: 600,
            background: 'linear-gradient(135deg, #4F8EF7, #7C5CFC)',
            border: 'none', borderRadius: 8, color: '#fff',
            cursor: 'pointer', fontFamily: 'inherit',
          }}>Save Changes</button>
        </div>
      </div>
    </div>
  );
}
